import styled from 'styled-components';

export const ReviewsCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(20, 25, 40, 0.04);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 16px;
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ReviewsColumn = styled.div`
  padding: 24px 26px;
  border-right: 1px solid #e3e5ea;
  min-width: 0;

  &:last-child {
    border-right: 0;
  }

  &.pending {
    background: linear-gradient(0deg, #fffafa, #fff);
  }

  @media (max-width: 900px) {
    border-right: 0;
    border-bottom: 1px solid #e3e5ea;

    &:last-child {
      border-bottom: 0;
    }
  }
`;

export const ColumnHeader = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #2b3440;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ColumnIcon = styled.span`
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    display: block;
  }
`;

export const ActionPill = styled.span`
  margin-left: auto;
  background: #fff1f2;
  color: #d4212b;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
  padding: 3px 10px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  flex-shrink: 0;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ff2d38;
  }
`;

export const ColumnValue = styled.div`
  font-size: 46px;
  font-weight: 300;
  line-height: 1;
  margin: 14px 0 14px;
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  color: #2b3440;
`;

export const ValueCaption = styled.em`
  font-style: normal;
  font-size: 14px;
  color: #8a93a0;
  font-weight: 400;
  line-height: 1.3;
`;

export const RatingSub = styled.span`
  display: block;
  font-size: 13px;
  color: #8a93a0;
  font-weight: 400;
`;

export const ReplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 2px solid #ff2d38;
  color: #ff2d38;
  border-radius: 20px;
  padding: 5px 16px 5px 12px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  background: #fff;
  cursor: pointer;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    background: #ff2d38;
    color: #fff;
  }
`;

export const CaughtUp = styled.div`
  color: #1fb57a;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: end;
`;
